import { AppointmentType } from '../../../../../API/Enums';
import { CheckInsProps } from '../CheckIns.types';

export const AppointmentColors: Readonly<Record<AppointmentType, string>> = {
    [AppointmentType.none]: '#171482',
    [AppointmentType.checkedIn]: '#52bf24',
    [AppointmentType.created]: '#0099ff',
    [AppointmentType.dmsAppointment]: '#cc6600',
    [AppointmentType.priority]: '#ff0000',
    [AppointmentType.keyDroppedOff]: '#52bf24',
    [AppointmentType.inKeyBin]: '#590e8f',
    [AppointmentType.rentalOrLoanerInBin]: '#52bf24',
} as const;

export interface FilterProps {
    includeFilters: AppointmentType[];
    tabType: CheckInsProps['tabType'];
}